import React, { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useFetchApi } from "../../hooks"
import { LangContext } from "../../LangProvider"
import AchievementSkeleton from "./AchievementSkeleton"
import donation from "../../assets/img/donation.png"
import hospital from "../../assets/img/hospital.png"
import ricebox from "../../assets/img/ricebox.png"

function Achievement() {
  const { t } = useTranslation()
  const { lang } = useContext(LangContext)
  const [{ data: achievement, loading }, doFetch] = useFetchApi(
    `/achieve?lang=${lang}`,
    {}
  )

  useEffect(() => {
    doFetch(`/achieve?lang=${lang}`, {})
  }, [lang])

  return (
    <div
      className="uk-margin-large-top uk-container-large uk-container uk-text-center"
      id="achievement"
    >
      <h1 className="uk-margin-medium-bottom uk-text-bold">
        {t("home.achievement")}
      </h1>
      <div className="uk-padding uk-child-width-1-3@s" uk-grid="true">
        {loading ? (
          <AchievementSkeleton />
        ) : (
          <>
            <div>
              <div className="achievement-icon">
                <img src={donation} alt="donation" />
              </div>
              <p>{achievement.totalDonation}</p>
            </div>
            <div>
              <div className="achievement-icon">
                <img src={hospital} alt="hospital" />
              </div>
              <p>{achievement.hospitals}</p>
            </div>
            <div>
              <div className="achievement-icon">
                <img src={ricebox} alt="ricebox" />
              </div>
              <p>{achievement.nasBung}</p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Achievement
